import { AnalysisResponse } from "./AnalysisResponse";
import { AnalysisResponseTERA } from "./AnalysisResponseTERA";

export const toAnalysisResponse = (analysisResponse: any, majorType: string) => {
    switch(majorType) {
        case 'AHVVA':
            return AnalysisResponse(analysisResponse);
            break;
        case 'TERA':
            return AnalysisResponseTERA(analysisResponse);
        default:
            return AnalysisResponse(analysisResponse);
    }
}